/**
 *
 * Asynchronously loads the component for Video Module
 *
 */

import loadable from "core/components/loadable";

export default loadable(() => import("./index"));
